import React from 'react';
import '../styles/Features.css';
import { Heart, Star, Sparkles, UserCheck } from 'lucide-react';
import { motion } from 'framer-motion';

function Features() {
  const features = [
    { icon: <Heart size={24} />, title: "Ambiente cálido", desc: "Relajado y muy cercano" },
    { icon: <UserCheck size={24} />, title: "Trato personalizado", desc: "Cuidado al detalle para ti" },
    { icon: <Star size={24} />, title: "Materiales premium", desc: "La mejor calidad del mercado" },
    { icon: <Sparkles size={24} />, title: "Resultados únicos", desc: "Realzamos tu belleza natural" }
  ];

  return (
    <div className="features section">
      <div className="section-title">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          Por qué te sentirás como en casa
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
        >
          Todo está pensado para tu confort
        </motion.p>
      </div>
      
      <div className="features-grid">
        {features.map((feature, index) => (
          <motion.div 
            key={index}
            className="feature-card glass-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
            whileHover={{ y: -5 }}
          >
            <div className="feature-icon">{feature.icon}</div>
            <h3>{feature.title}</h3>
            <p>{feature.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default Features;
